export class Tag {
	id = null;
	name = null;

	constructor(data) {
		Object.assign(this, data);
	}

	isSame(otherTag) {
		return (
			this.id == otherTag.id &&
			this.name == otherTag.name
		);
	}
} 